import { useScrollReveal } from '../hooks/useScrollReveal';
import { useParallax } from '../hooks/useParallax';

const abilityLadder = [
  { level: '第一层', label: '看见画面', desc: '识别PPT页、板书、视频播放、教师位置和课堂活动' },
  { level: '第二层', label: '理解片段', desc: '判断属于导入、史料呈现、现实分析还是总结升华' },
  { level: '第三层', label: '进入评价', desc: '画面与语音文本、课件内容和评价指标对应' },
];

export default function P27VisualUnderstanding({ forceVisible = false }: { forceVisible?: boolean }) {
  const { ref: titleRef, isVisible: titleVisible } = useScrollReveal(0.12, forceVisible);
  const { ref: orb1Ref, offset: orb1Y } = useParallax(0.05);
  const { ref: orb2Ref, offset: orb2Y } = useParallax(-0.04);

  return (
    <div className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* 三层背景光效 */}
      <div ref={orb1Ref} className="absolute top-20 right-24 w-[380px] h-[380px] rounded-full bg-primary-200/30 blur-[120px] pointer-events-none" style={{ transform: `translateY(${orb1Y}px)` }} />
      <div ref={orb2Ref} className="absolute bottom-28 left-12 w-[400px] h-[400px] rounded-full bg-accent-200/25 blur-[110px] pointer-events-none" style={{ transform: `translateY(${orb2Y}px)` }} />
      <div className="absolute top-1/2 left-1/3 w-[300px] h-[300px] rounded-full bg-secondary-200/20 blur-[140px] pointer-events-none animate-orb-float-3" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div ref={titleRef} className="text-center mb-8 md:mb-10">
          <div className={`flex items-center justify-center gap-2 mb-3 transition-all duration-700 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/60 text-primary-700 text-sm font-body font-semibold">
              <i className="ri-scan-line text-sm" /> 技术点一
            </span>
          </div>
          <h2 className={`font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 transition-all duration-1000 delay-100 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            长视频切片与<span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">课堂视觉理解</span>
          </h2>
        </div>

        {/* 三级能力阶梯 */}
        <div className={`max-w-5xl mx-auto mb-8 md:mb-10 transition-all duration-1000 delay-200 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            {abilityLadder.map((step, i) => (
              <div
                key={step.level}
                className={`p-7 md:p-9 rounded-2xl glass border-white/50 text-center hover:border-primary-200/40 transition-all duration-500 ${titleVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${400 + i * 150}ms` }}
              >
                <p className="text-lg md:text-xl font-body font-semibold text-foreground-950">{step.level}</p>
                <p className="text-2xl md:text-3xl font-body font-bold text-foreground-950 mt-2">{step.label}</p>
                <p className="text-lg md:text-xl text-foreground-950 font-body mt-3 leading-relaxed max-w-xs mx-auto">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}